module.exports = fox._r("fonts/kreon-regular-webfont.ttf", __webpack_public_path__ + "_/_/_/common/frame/fonts/3CntYlf.ttf");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/fonts/kreon-regular-webfont.ttf
// module id = 103
// module chunks = 2